import { Head } from '@inertiajs/react';
import { type ReactNode, useEffect, useState } from 'react';
import Countdown from './components/countdown';
import Description from './components/description';
import Features from './components/features';
import Footer from './components/footer';
import Hero from './components/hero';
import Location from './components/location';
import Prize from './components/prize';
import Sponsors from './components/sponsors';
import { DEADLINE } from './constants';
import type { Hack24Show } from '@/types';

// `app/24/page.js` — the Hack 24 landing, Santiago 2024. The oldest page on the site and
// the only one written before the (public) route group existed, so it shares nothing with
// the tour-stop landings: its own palette, its own fonts, its own everything. Ported as a
// self-contained page directory for that reason rather than folded into Landings/.
//
// The countdown section only mounts while applications are open, which they have not been
// since 2024-11-13 — same condition, same result as the live page.
export default function Show({ title, description }: Hack24Show) {
  const [hasLoggedMessage, setHasLoggedMessage] = useState(false);

  useEffect(() => {
    if (hasLoggedMessage) return;

    console.log(
      '%chey, you look like a hacker. we have a cool hackathon for you. apply at https://platan.us/hack/apply/devtools',
      'font-size: 30px; color: #FFEC40; font-weight: bold;',
    );
    setHasLoggedMessage(true);
  }, [hasLoggedMessage]);

  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
      </Head>
      <main className="relative">
        <Hero />
        <Description />
        <Prize />
        <Features />
        {DEADLINE > new Date() && <Countdown />}
        <Location />
        <Sponsors />
        <Footer />
      </main>
    </>
  );
}

// `app/24/layout.tsx` was a layout of its own, nested inside the root one: the whole page
// renders inside `.hack24-root.dark`, which is where its palette and font come from.
// Declaring it here also keeps PublicEditionLayout — the default for every page with no
// layout of its own — off a page that has no tour-stop shell (entrypoints/inertia.ts).
Show.layout = (page: ReactNode) => (
  <div className="hack24-root dark">{page}</div>
);
